/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does my data stay on my device?`)
};

const es_bubble_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Mis datos permanecen en mi dispositivo?`)
};

const de_bubble_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleiben meine Daten auf meinem Gerät?`)
};

const nl_bubble_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blijft mijn data op mijn apparaat?`)
};

const fr_bubble_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes données restent-elles sur mon appareil ?`)
};

const it_bubble_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I miei dati restano sul mio dispositivo?`)
};

const pt_br2_bubble_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meus dados permanecem no meu dispositivo?`)
};

const pt_bubble_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os meus dados permanecem no meu dispositivo?`)
};

const ja_bubble_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データは端末に留まりますか？`)
};

const zh_bubble_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的数据会留在我的设备上吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_faq_q4", locale)
	if (locale === "en") return en_bubble_faq_q4(inputs)
	if (locale === "es") return es_bubble_faq_q4(inputs)
	if (locale === "de") return de_bubble_faq_q4(inputs)
	if (locale === "nl") return nl_bubble_faq_q4(inputs)
	if (locale === "fr") return fr_bubble_faq_q4(inputs)
	if (locale === "it") return it_bubble_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_faq_q4(inputs)
	if (locale === "pt") return pt_bubble_faq_q4(inputs)
	if (locale === "ja") return ja_bubble_faq_q4(inputs)
	return zh_bubble_faq_q4(inputs)
};